import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {SegmentedButton, Size, TextArea, TextInput} from "@dts-soldel/dts-react-common";
import MobXContext from "../../../app/mobx/MobXContext";
import ENVIRONMENT from "../../../../../../src/js/misc/environment";
import HelpIcon from "../HelpIcon/HelpIcon";
import HelpText from "../HelpIcon/HelpText";

const propTypes = {};
const defaultProps = {};

const ConfiguratorUtahIdNonCustom = () => {
	const {configuratorStore} = useContext(MobXContext);

	return (
		<div className="configurator__inputs">
			<div className="configurator__inputs__input">
				<TextArea
					size={Size.FULL_WIDTH}
					field="utahId.authCallback"
					label="authCallback"
					value={configuratorStore.utahId.authCallback}
					onChange={configuratorStore.setFieldValue}
					children={
						<HelpIcon
							popOverText={HelpText.customIdAuthCallback}
							onUseExampleField="utahId.authCallback"
							onUseExampleFieldValue={configuratorStore.setFieldValue}
						/>
					}
				/>
			</div>
			<div className="configurator__inputs__input">
				<TextInput
					size={Size.FULL_WIDTH}
					field="utahId.customParams"
					label="customParams"
					value={configuratorStore.utahId.customParams}
					onChange={configuratorStore.setFieldValue}
					children={
						<HelpIcon
							popOverText={HelpText.customIdCustomParams}
							onUseExampleField="utahId.customParams"
							onUseExampleFieldValue={configuratorStore.setFieldValue}
						/>
					}
				/>
			</div>
			{
				configuratorStore.utahId.environment === ENVIRONMENT.CUSTOM ?
					<div className="configurator__inputs__input">
						<TextInput
							size={Size.FULL_WIDTH}
							field="utahId.customURL"
							label="customURL"
							value={configuratorStore.utahId.customURL}
							onChange={configuratorStore.setFieldValue}
							children={
								<HelpIcon
									popOverText={HelpText.customIdCustomUrl}
									onUseExampleField="utahId.customURL"
									onUseExampleFieldValue={configuratorStore.setFieldValue}
								/>
							}
						/>
					</div>
					: undefined
			}
			<div className="configurator__inputs__input">
				<SegmentedButton
					className="size-full"
					field="utahId.environment"
					label="environment"
					options={[
						{label: 'Custom', value: ENVIRONMENT.CUSTOM},
						{label: 'Dev', value: ENVIRONMENT.DEV},
						{label: 'AT', value: ENVIRONMENT.AT},
						{label: 'Prod', value: ENVIRONMENT.PROD},
					]}
					value={configuratorStore.utahId.environment}
					onChange={configuratorStore.setFieldValue}
					children={
						<HelpIcon
							popOverText={HelpText.customIdEnvironment}
							onUseExampleField="utahId.environment"
							onUseExampleFieldValue={configuratorStore.setFieldValue}
						/>
					}
				/>
			</div>
		</div>
	);
};

ConfiguratorUtahIdNonCustom.propTypes = propTypes;
ConfiguratorUtahIdNonCustom.defaultProps = defaultProps;

export default observer(ConfiguratorUtahIdNonCustom);
